import React from 'react';
import { withRouter } from 'react-router-dom'

class NavMenuItem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            hover: false
        };

        this.toggleHover = this.toggleHover.bind(this);
        this.gotoLink = this.gotoLink.bind(this);
    }

    toggleHover(e) {
        if(this) {
            this.setState(
                {
                    hover: !this.state.hover
                }
            );
            console.log("toggleHover()");
        }
        e.stopPropagation();
    }

    gotoLink() {
        this.props.history.push(this.props.pushTo);
    }

    render() {


        var menuItemStyle = {
            cursor: "pointer",
            color: "#ccc",
            backgroundColor: "#3a3a3a",
            paddingTop: 5,
            paddingBottom: 5,
            paddingLeft: 7,
            marginLeft: 8,
            paddingRight: 7,
            marginRight: 8,
            marginBottom: 8,
            fontFamily: "Muli",
            fontSize: 18,
        }

        var menuItemHoverStyle = {
            cursor: "pointer",
            color: "#FFF",
            backgroundColor: "#000",
            paddingTop: 5,
            paddingBottom: 5,
            paddingLeft: 7,
            marginLeft: 8,
            marginBottom: 8,
            paddingRight: 7,
            marginRight: 8,
            fontFamily: "Muli",
            fontSize: 18,
        }

        var currStyle = menuItemStyle;
        if(this.state.hover) currStyle = menuItemHoverStyle;
        currStyle["width"] = this.props.itemwidth;
       return (
                <span
                    style={currStyle}
                    onClick={this.gotoLink}
                    onMouseOver={(e) => this.toggleHover(e)}
                    onMouseOut={(e) => this.toggleHover(e)}
                >
                    {this.props.text}
                </span>
        );
    }
}

export default withRouter(NavMenuItem)



// WEBPACK FOOTER //
// src/NavMenuItem.js